// extracted by mini-css-extract-plugin
var _1 = "BALogoText__baLogo--zHBBC";
var _2 = "BALogoText__baLogoLarge--jJhUd";
var _3 = "BALogoText__baLogoText--Wwpie";
var _4 = "BALogoText__baText--NNnjC";
var _5 = "BALogoText__logoHiding--_O23M";
export { _1 as "baLogo", _2 as "baLogoLarge", _3 as "baLogoText", _4 as "baText", _5 as "logoHiding" }
